module.exports = __webpack_public_path__ + "media/assets/twitter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/twitter.svg
// module id = 31
// module chunks = 0